import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactSelect from 'react-select';
import { components } from '../Utils/ReactSelectComponents';
import { FormControl, Grid, InputAdornment, InputLabel, TextField, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { handleSpecialCharacters } from '../../Utils/Helper';


const styles = theme => ({
  titleHead: {
    backgroundColor: '#F6F6F6',
    flex: '0 0 auto'
  },
  secondToolBar: {
    padding: '0px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '52px'
  },
  searchArea: {
    display: 'flex',
    alignItems: 'inherit'
  },
  formControl: {
    minWidth: '240px'
  },
  searchSC: {
    padding: '0 12px',
    textAlign: 'left',
    minWidth: '300px'
  },
  searchField: {
    width: '240px',
    marginTop: '20px'
  },
  searchIconMargin: {
    marginRight: '4px'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  },
  chip: {
    margin: theme.spacing.unit / 6
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  }
});


class ReservationsToolbar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      searchBy: '',
      saleChannel: [],
      salesChannelsIds: []
    }
  }

  handleSearchSC = selectedSalesChannels => {
    this.setState({ saleChannel: selectedSalesChannels });

    let SalesChannelsIds = [];
    selectedSalesChannels.forEach((item) => {
      SalesChannelsIds.push(item.value);
    });

    this.setState({ salesChannelsIds: SalesChannelsIds });

    this.props.reloadTableBySearch(this.state.searchBy, SalesChannelsIds);
  };

  handleSearch = event => {
    this.setState({ searchBy: handleSpecialCharacters(event.target.value) });
    this.props.reloadTableBySearch(handleSpecialCharacters(event.target.value), this.state.salesChannelsIds);
  };

  componentWillUnmount() {
    this.setState({
      searchBy: '',
      saleChannel: [],
      salesChannelsIds: []
    });
  }


  render() {
    const { classes } = this.props;

    return (
      <div className={classes.secondToolBar}>

        <Typography className={classes.titleHead} variant='title' id='tableTitle'>
          {this.props.tableTitle}
        </Typography>

        <div className={classes.searchArea}>
          {this.props.withSCSearch ?
            <div className={classes.searchSC}>
              <InputLabel htmlFor='SaleChannels'>CANAL DE VENDA</InputLabel>
              <ReactSelect
                classes={classes}
                options={this.props.saleChannelData}
                components={components}
                value={this.state.saleChannel}
                onChange={this.handleSearchSC}
                placeholder=''
                isMulti
              />
            </div>
            : null
          }
          <FormControl className={classes.formControl}>
            <Grid container spacing={8} alignItems='flex-end'>
              <Grid item>
                <TextField
                  id='search'
                  label=''
                  placeholder='Pesquisar'
                  type='search'
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start' className={classes.searchIconMargin}>
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  className={classes.searchField}
                  value={this.state.searchBy}
                  onChange={this.handleSearch}
                />
              </Grid>
            </Grid>
          </FormControl>
        </div>

      </div>
    );
  }
};

ReservationsToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func.isRequired
};

export default withStyles(styles)(ReservationsToolbar);


// WEBPACK FOOTER //
// ./src/components/Reservations/ReservationsToolbar.js